import React, { useState } from 'react';
import {
  FormControl,
  OutlinedInput,
  InputAdornment,
  IconButton,
  Box,
  FormHelperText,
  Typography
} from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';

const PasswordField = ({ errors, setErrors, setPassword,setConfirmPassword, password, comaparePassword = "",hintVisible = false, ...props }) => {
  const [passwordVisible, setVisible] = useState(false);
  const { name } = props;

  const onPasswordEntered = (e) => {
    clearTimeout();
    const { value } = e.target;

    // setTimeout(() => {
      if(name == 'password'){
        setPassword(value);
        if (!new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,15}$/).test(value)) {
          return setErrors({ ...errors, [name]: 'Password must 8 and 15 digits long and include at least one numeric digit, one lower case letter and one upper case letter' });
        }
      }
      if(name == 'confirm_password'){
        setConfirmPassword(value);
        if (comaparePassword != value) {
          return setErrors({ ...errors, [name]: 'Confirm password must be same as password' });
        }
      }
      
      
      // if (!new RegExp(/[0-9]/).test(value)) {
      //   return setErrors({ ...errors, [name]: 'Password is missing numbers' });
      // }
      // if (!new RegExp(/[$-/\\:-?{-~!"^_`@#[\]]/).test(value)) {
      //   return setErrors({ ...errors, [name]: 'Password is missing symbols, e.g. [ $-/:-?( ) { }~!"^_`@#[ ] ]' });
      // }
      return setErrors({ ...errors, [name]: null });
    // }, 2000);

    
  };

  return (
    <FormControl style={{ marginBottom: 12, width: '100%' }}>
      <OutlinedInput
        
        fullWidth
        error={Boolean(errors && errors[name])}
        variant="outlined"
        type={passwordVisible ? 'text' : 'password'}
        value={password}
        onChange={onPasswordEntered}
        // inputProps={{
        //   pattern: '(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+-]).{8,}',
        //   minLength: 8,
        //   'data-testid': 'common-password-field'
        // }}
        endAdornment={(
          <InputAdornment position="end">
            <IconButton aria-label="toggle password visibility" onClick={() => setVisible(!passwordVisible)}>
              {passwordVisible ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        )}
        {...props}
      />
      <FormHelperText error={Boolean(errors && errors[name])}>{errors && errors[name]}</FormHelperText>
      {hintVisible && (
        <Box color="#aaa" fontSize={11}>
          {/* <Typography>Password must 8 and 15 digits long and include at least one numeric digit, one lower case letter and one upper case letter</Typography> */}
        </Box>
      )}
    </FormControl>
  );
};

export default PasswordField;
